import { Articles } from '@cookspace-shared-contracts/core';

import { baseApi } from '@/api/baseApi';
import { parseWithSchema } from '@/lib/safeParse';

/**
 * RTK Query endpoints для admin-backend /articles/*.
 * Read-only режим: list (всех статусов) и get details по slug.
 * admin-backend на порту 5002 без префикса /admin.
 */
export const articlesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        listArticles: build.query<
            Articles.GetArticlesResponse,
            Articles.GetArticlesRequest | void
        >({
            query: (params) => {
                const search: Record<string, string> = {};
                if (params?.search) {
                    search.search = params.search;
                }
                if (params?.categoryId) {
                    search.categoryId = params.categoryId;
                }
                if (params?.isPremium !== undefined) {
                    search.isPremium = params.isPremium ? 'true' : 'false';
                }
                if (params?.authorId) {
                    search.authorId = params.authorId;
                }
                if (params?.limit !== undefined) {
                    search.limit = String(params.limit);
                }
                if (params?.offset !== undefined) {
                    search.offset = String(params.offset);
                }
                return {
                    url: '/articles',
                    method: 'GET',
                    params: search
                };
            },
            transformResponse: (raw: unknown): Articles.GetArticlesResponse =>
                parseWithSchema(Articles.GetArticlesResponseSchema, raw),
            providesTags: (result) =>
                result
                    ? [
                        ...result.items.map((a) => ({
                            type: 'Article' as const,
                            id: a.id
                        })),
                        { type: 'Article' as const, id: 'LIST' }
                    ]
                    : [{ type: 'Article' as const, id: 'LIST' }]
        }),

        getArticleBySlug: build.query<Articles.GetArticleResponse, { slug: string }>({
            query: ({ slug }) => ({
                url: `/articles/${slug}`,
                method: 'GET'
            }),
            transformResponse: (raw: unknown): Articles.GetArticleResponse =>
                parseWithSchema(Articles.GetArticleResponseSchema, raw),
            providesTags: (result) =>
                result ? [{ type: 'Article' as const, id: result.article.id }] : []
        })
    })
});

export const { useListArticlesQuery, useGetArticleBySlugQuery } = articlesApi;
